import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CourseMap from './CourseMap';

// Available courses for selection
export const COURSES = {
  // Free courses
  '1': {
    name: 'Burnaby Mountain Golf Course',
    municipality: 'burnaby',
    backendId: '1',
    requiresAuth: false,
    isPremium: false
  },
  '2': {
    name: 'Riverway Golf Course',
    municipality: 'burnaby',
    backendId: '2',
    requiresAuth: false,
    isPremium: false
  },
  '3': {
    name: 'Langara',
    municipality: 'vancouver',
    backendId: '1',
    requiresAuth: false,
    isPremium: false
  },
  '4': {
    name: 'Fraserview Golf Course',
    municipality: 'vancouver',
    backendId: '2',
    requiresAuth: false,
    isPremium: false
  },
  '5': {
    name: 'McCleery Golf Course',
    municipality: 'vancouver',
    backendId: '3',
    requiresAuth: false,
    isPremium: false
  },
  // Premium courses (require premium subscription)
  '8': {
    id: '8',
    name: 'Seymour Golf and Country Club',
    municipality: 'North Vancouver',
    apiType: 'igolfsystems',
    backendId: 'seymour',
    requiresAuth: false,
    isPremium: true
  },
  '9': {
    name: 'Gleneagles Golf Course',
    municipality: 'West Vancouver',
    backendId: '1',
    requiresAuth: false,
    isPremium: true
  },
  '7': {
    name: 'Northlands Golf Course',
    municipality: 'North Vancouver',
    backendId: '1',
    requiresAuth: true,
    isPremium: true
  },
  '6': {
    name: 'University Golf Club',
    municipality: 'Vancouver',
    backendId: 'university',
    requiresAuth: false,
    isPremium: true
  },
  '10': {
    name: 'Sky Course - GreenTee Country Club',
    municipality: 'Coquitlam',
    backendId: 'skyCourse',
    requiresAuth: false,
    isPremium: true
  },
  '11': {
    name: 'Fine Course - GreenTee Country Club',
    municipality: 'Coquitlam',
    backendId: 'fineCourse',
    requiresAuth: false,
    isPremium: true
  },
  '12': {
    name: 'Carnoustie Golf Club',
    municipality: 'Port Coquitlam',
    backendId: 'carnoustie',
    requiresAuth: false,
    isPremium: true
  },
  '13': {
    name: 'Golden Eagle Golf Club - North Course',
    municipality: 'Pitt Meadows',
    backendId: 'genorthcourse',
    requiresAuth: false,
    isPremium: true
  },
  '14': {
    name: 'Golden Eagle Golf Club - South Course',
    municipality: 'Pitt Meadows',
    backendId: 'gesouthcourse',
    requiresAuth: false,
    isPremium: true
  },
  '15': {
    name: 'Surrey Golf Club - Main Course',
    municipality: 'Surrey',
    backendId: 'surreygolfclub',
    requiresAuth: false,
    isPremium: true
  },
  '16': {
    name: 'Surrey Golf Club - Willows 9',
    municipality: 'Surrey',
    backendId: 'surreywillows',
    requiresAuth: false,
    isPremium: true
  },
  '17': {
    name: 'Savage Creek Golf Course',
    municipality: 'Richmond',
    backendId: 'savagecreek',
    requiresAuth: false,
    isPremium: true
  },
  '18': {
    name: 'Mylora Golf Course',
    municipality: 'Richmond',
    backendId: 'mylora',
    requiresAuth: false,
    isPremium: true
  },
  '19': {
    name: 'Country Meadows Golf Course',
    municipality: 'Richmond',
    backendId: 'countrymeadows',
    requiresAuth: false,
    isPremium: true
  },
  '20': {
    name: 'Furry Creek Golf and Country Club',
    municipality: 'Furry Creek',
    backendId: 'furrycreek',
    requiresAuth: false,
    isPremium: true
  },
  '21': {
    name: 'Meadow Gardens Golf Club',
    municipality: 'Pitt Meadows',
    backendId: 'meadowgardens',
    requiresAuth: false,
    isPremium: true
  },
  '22': {
    name: 'Musqueam Golf & Learning Academy',
    municipality: 'Vancouver',
    backendId: 'musqueam',
    requiresAuth: false,
    isPremium: true
  },
  '23': {
    name: 'The Hills at Portal Golf Club',
    municipality: 'White Rock',
    backendId: 'hillsatportal',
    requiresAuth: false,
    isPremium: true
  },
  '24': {
    name: 'Meridian Hills Golf Par 3',
    municipality: 'White Rock',
    backendId: 'meridianhills',
    requiresAuth: false,
    isPremium: true
  },
  '25': {
    name: 'Harrison Resort Golf Course',
    municipality: 'Agassiz',
    backendId: 'harrisonresort',
    requiresAuth: false,
    isPremium: true
  },
  '26': {
    name: 'The Falls Golf Club',
    municipality: 'Chilliwack',
    backendId: 'thefalls',
    requiresAuth: false,
    isPremium: true
  },
  '27': {
    name: 'Tsawwassen Springs Golf',
    municipality: 'Delta',
    backendId: 'tsawwassensprings',
    requiresAuth: false,
    isPremium: true
  },
  '28': {
    name: 'Sandpiper Resort Golf Course',
    municipality: 'Harrison Mills',
    backendId: 'sandpiperresort',
    requiresAuth: false,
    isPremium: true
  },
  '29': {
    name: 'Hope Golf & Country Club',
    municipality: 'Hope',
    backendId: 'hopegolf',
    requiresAuth: false,
    isPremium: true
  },
  '30': {
    name: 'GreenTee Country Club Langley',
    municipality: 'Langley',
    backendId: 'greenteelangley',
    requiresAuth: false,
    isPremium: true
  },
  '31': {
    name: 'Mount Brenton Golf Club',
    municipality: 'Chemainus',
    backendId: 'mountbrenton',
    requiresAuth: false,
    isPremium: true
  },
  '32': {
    name: 'Arbutus Ridge Golf Club',
    municipality: 'Cobble Hill',
    backendId: 'arbutusridge',
    requiresAuth: false,
    isPremium: true
  },
  '33': {
    name: 'The Park at Crown Isle',
    municipality: 'Comox',
    backendId: 'crownislepark',
    requiresAuth: false,
    isPremium: true
  },
  '34': {
    name: 'Crown Isle Resort and Golf Community',
    municipality: 'Courtenay',
    backendId: 'crownisleresort',
    requiresAuth: false,
    isPremium: true
  },
  '35': {
    name: 'Mulligans Golf Course',
    municipality: 'Courtenay',
    backendId: 'mulligans',
    requiresAuth: false,
    isPremium: true
  },
  '36': {
    name: 'Sunnydale Golf and Country Club',
    municipality: 'Courtenay',
    backendId: 'sunnydale',
    requiresAuth: false,
    isPremium: true
  },
  '37': {
    name: 'Cowichan Golf & Country Club',
    municipality: 'Duncan',
    backendId: 'cowichan',
    requiresAuth: false,
    isPremium: true
  },
  '38': {
    name: 'Duncan Meadows Golf Course',
    municipality: 'Duncan',
    backendId: 'duncanmeadows',
    requiresAuth: false,
    isPremium: true
  },
  '39': {
    name: 'March Meadows Golf Club',
    municipality: 'Honeymoon Bay',
    backendId: 'marchmeadows',
    requiresAuth: false,
    isPremium: true
  },
  '40': {
    name: 'Morningstar Golf Club',
    municipality: 'Parksville',
    backendId: 'morningstar',
    requiresAuth: false,
    isPremium: true
  },
  '41': {
    name: 'Salt Spring Island Golf Club',
    municipality: 'Salt Spring Island',
    backendId: 'saltspring',
    requiresAuth: false,
    isPremium: true
  },
  '42': {
    name: 'Bear Mountain Golf Resort - Mountain Course',
    municipality: 'Victoria',
    backendId: 'bearmountainmountain',
    requiresAuth: false,
    isPremium: true
  },
  '43': {
    name: 'Bear Mountain Golf Resort - Valley Course',
    municipality: 'Victoria',
    backendId: 'bearmountainvalley',
    requiresAuth: false,
    isPremium: true
  },
  '44': {
    name: 'Metchosin Golf Course',
    municipality: 'Victoria',
    backendId: 'metchosin',
    requiresAuth: false,
    isPremium: true
  },
  '45': {
    name: 'Big Sky Golf Club',
    municipality: 'Pemberton',
    backendId: 'bigsky',
    requiresAuth: false,
    isPremium: true
  },
  '46': {
    name: 'Fairmont Chateau Whistler Golf Club',
    municipality: 'Whistler',
    backendId: 'chateauwhistler',
    requiresAuth: false,
    isPremium: true
  },
  '47': {
    name: 'Bighorn Golf & Country Club',
    municipality: 'Kamloops',
    backendId: 'bighorn',
    requiresAuth: false,
    isPremium: true
  },
  '48': {
    name: 'Eaglepoint Golf Resort',
    municipality: 'Kamloops',
    backendId: 'eaglepoint',
    requiresAuth: false,
    isPremium: true
  },
  '49': {
    name: 'Kamloops Golf & Country Club',
    municipality: 'Kamloops',
    backendId: 'kamloopsgolf',
    requiresAuth: false,
    isPremium: true
  },
  '50': {
    name: 'Mount Paul Golf Course',
    municipality: 'Kamloops',
    backendId: 'mountpaul',
    requiresAuth: false,
    isPremium: true
  },
  '51': {
    name: 'Michaelbrook Golf',
    municipality: 'Kelowna',
    backendId: 'michaelbrook',
    requiresAuth: false,
    isPremium: true
  },
  '52': {
    name: 'Mission Creek Golf Club',
    municipality: 'Kelowna',
    backendId: 'missioncreek',
    requiresAuth: false,
    isPremium: true
  },
  '53': {
    name: 'Sunset Ranch Golf and Country Club',
    municipality: 'Kelowna',
    backendId: 'sunsetranch',
    requiresAuth: false,
    isPremium: true
  },
  '54': {
    name: 'Tower Ranch Golf Club',
    municipality: 'Kelowna',
    backendId: 'towerranch',
    requiresAuth: false,
    isPremium: true
  },
  '55': {
    name: 'Merritt Golf & Country Club',
    municipality: 'Merritt',
    backendId: 'merrittgolf',
    requiresAuth: false,
    isPremium: true
  },
  '56': {
    name: 'Predator Ridge Resort',
    municipality: 'Vernon',
    backendId: 'predatorridge',
    requiresAuth: false,
    isPremium: true
  },
  '57': {
    name: 'Spallumcheen Golf & Country Club',
    municipality: 'Vernon',
    backendId: 'spallumcheen',
    requiresAuth: false,
    isPremium: true
  },
  '58': {
    name: 'The Rise Resort',
    municipality: 'Vernon',
    backendId: 'theriseresort',
    requiresAuth: false,
    isPremium: true
  },
  '59': {
    name: "Tobiano Golf Course",
    municipality: 'Kamloops',
    backendId: 'tobiano',
    requiresAuth: false,
    isPremium: true
  },
  '60': {
    name: "Talking Rock Golf Course",
    municipality: 'Chase',
    backendId: 'talkingrock',
    requiresAuth: false,
    isPremium: true
  },
  '61': {
    name: "Sun Peaks Golf Course",
    municipality: 'Sun Peaks',
    backendId: 'sunpeaks',
    requiresAuth: false,
    isPremium: true
  },
  '62': {
    name: "Shuswap National Golf Course",
    municipality: 'Salmon Arm',
    backendId: 'shuswapnational',
    requiresAuth: false,
    isPremium: true
  },
  '63': {
    name: "Summerland Golf & Country Club",
    municipality: 'Summerland',
    backendId: 'summerland',
    requiresAuth: false,
    isPremium: true
  },
  '64': {
    name: "Fairview Mountain Golf Club",
    municipality: 'Oliver',
    backendId: 'fairviewmountain',
    requiresAuth: false,
    isPremium: true
  },
  '65': {
    name: "NK'Mip Canyon Desert Golf Course",
    municipality: 'Oliver',
    backendId: 'nkmipcanyon',
    requiresAuth: false,
    isPremium: true
  },
  '66': {
    name: "Osoyoos Golf Club - Desert Gold",
    municipality: 'Osoyoos',
    backendId: 'osoyoosdesertgold',
    requiresAuth: false,
    isPremium: true
  },
  '67': {
    name: "Osoyoos Golf Club - Park Meadows",
    municipality: 'Osoyoos',
    backendId: 'osoyoosparkmeadows',
    requiresAuth: false,
    isPremium: true
  },
  '68': {
    name: "Revelstoke Golf Club",
    municipality: 'Revelstoke',
    backendId: 'revelstoke',
    requiresAuth: false,
    isPremium: true
  },
  '69': {
    name: "Princeton Golf Club",
    municipality: 'Princeton',
    backendId: 'princeton',
    requiresAuth: false,
    isPremium: true
  },
  '70': {
    name: "Storey Creek Golf Club",
    municipality: 'Campbell River',
    backendId: 'storeycreek',
    requiresAuth: false,
    isPremium: true
  },
  '71': {
    name: "Qualicum Beach Memorial Golf Club",
    municipality: 'Qualicum Beach',
    backendId: 'qualicumbeach',
    requiresAuth: false,
    isPremium: true
  },
  '72': {
    name: "Blue Ocean Golf Club",
    municipality: 'Sechelt',
    backendId: 'blueocean',
    requiresAuth: false,
    isPremium: true
  },
  '73': {
    name: "Cove Links Golf Course",
    municipality: 'Delta',
    backendId: 'covelinks',
    requiresAuth: false,
    isPremium: true
  },
  '74': {
    name: "Northview Golf & Country Club - Ridge Course",
    municipality: 'Surrey',
    backendId: '1',
    requiresAuth: false,
    isPremium: true
  },
  '75': {
    name: "Northview Golf & Country Club - Canal Course",
    municipality: 'Surrey',
    backendId: '2',
    requiresAuth: false,
    isPremium: true
  },
  '76': {
    name: "Morgan Creek Golf Course",
    municipality: 'Surrey',
    backendId: '2',
    requiresAuth: false,
    isPremium: true
  },
  '77': {
    name: "Delta Golf Club",
    municipality: 'Delta',
    backendId: '2',
    requiresAuth: false,
    isPremium: true
  },
  '78': {
    name: "Kings Links by the Sea",
    municipality: 'Delta',
    backendId: '1',
    requiresAuth: false,
    isPremium: true
  },
  '79': {
    name: "Belmont Golf Course",
    municipality: 'Langley',
    backendId: '2',
    requiresAuth: false,
    isPremium: true
  },
  '80': {
    name: "Swan-e-set Bay Resort - Resort Course",
    municipality: 'Pitt Meadows',
    backendId: '3',
    requiresAuth: false,
    isPremium: true
  },
  '81': {
    name: "Swan-e-set Bay Resort - Links Course",
    municipality: 'Pitt Meadows',
    backendId: '4',
    requiresAuth: false,
    isPremium: true
  },
  '82': {
    name: "Hazelmere Golf Course",
    municipality: 'Surrey',
    backendId: '1',
    requiresAuth: false,
    isPremium: true
  },
  '83': {
    name: "The Redwoods Golf Course",
    municipality: 'Langley',
    backendId: '1',
    requiresAuth: false,
    isPremium: true
  },
  '84': {
    name: "Two Eagles Golf Course",
    municipality: 'West Kelowna',
    backendId: '2',
    requiresAuth: false,
    isPremium: true
  },
  '85': {
    name: "Guildford Golf & Country Club",
    municipality: 'Surrey',
    backendId: 'guildford',
    requiresAuth: false,
    isPremium: true
  },
};

// Responsive hook
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 640);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

const SearchForm = () => {
  console.log('=== SearchForm component rendering ===');
  
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = React.useState(true);
  const isMobile = useIsMobile();
  const [showMap, setShowMap] = React.useState(false);
  // Filters which courses are listed. Purely a find-it affordance for a list
  // that is now 85 long; it never changes what gets submitted.
  const [courseQuery, setCourseQuery] = React.useState('');

  // Initialize form state after we know the auth state
  const [formState, setFormState] = React.useState(() => {
    // Seeds the default selection only. Every course is selectable now that
    // search is free; this just keeps a first-load search from fanning out to
    // all 85 courses (and therefore to every vendor API) at once.
    const initialSelectedCourses = Object.keys(COURSES).filter(id => !COURSES[id].isPremium);
    return {
      date: new Date().toISOString().split('T')[0],
      players: '2',
      timeRange: 'all',
      maxPrice: 200,
      selectedCourseIds: initialSelectedCourses
    };
  });

  // Wait for auth state to be determined
  React.useEffect(() => {
    setLoading(false);
  }, [currentUser]);

  React.useEffect(() => {
    const timeout = setTimeout(() => setShowMap(true), 300);
    return () => clearTimeout(timeout);
  }, []);

  // Handle course selection changes
  const handleCourseToggle = (courseId) => {
    setFormState(prev => ({
      ...prev,
      selectedCourseIds: prev.selectedCourseIds.includes(courseId)
        ? prev.selectedCourseIds.filter(id => id !== courseId)
        : [...prev.selectedCourseIds, courseId]
    }));
  };

  const handleSubmit = (e) => {
    console.log('=== handleSubmit function called ===');
    e.preventDefault();
    
    console.log('Search button clicked - about to send GA event');
    console.log('formState:', formState);
    console.log('selectedCourseIds length:', formState.selectedCourseIds.length);
    
    if (formState.selectedCourseIds.length === 0) {
      console.log('No courses selected - showing alert');
      alert('Please select at least one course');
      return;
    }
    
    console.log('Courses selected, proceeding with GA event');
    
    if (window.gtag) {
      console.log('Sending search_tee_times_clicked event with data:', {
        selected_courses_count: formState.selectedCourseIds.length,
        date: formState.date,
        players: formState.players,
        time_range: formState.timeRange,
        max_price: formState.maxPrice,
      });
      
      window.gtag('event', 'search_tee_times_clicked', {
        selected_courses_count: formState.selectedCourseIds.length,
        date: formState.date,
        players: formState.players,
        time_range: formState.timeRange,
        max_price: formState.maxPrice,
      });
      
      console.log('Search GA event sent successfully');
    } else {
      console.error('window.gtag not available in search form');
    }

    if (formState.selectedCourseIds.length === 0) {
      alert('Please select at least one course');
      return;
    }

    const searchParams = new URLSearchParams({
      courses: formState.selectedCourseIds.join(','),
      date: formState.date,
      players: formState.players,
      timeRange: formState.timeRange,
      maxPrice: formState.maxPrice
    });

    console.log('Navigating to results with params:', searchParams.toString());
    navigate(`/results?${searchParams.toString()}`);
  };

  const { date, players, timeRange, maxPrice, selectedCourseIds } = formState;

  if (loading) {
    return (
      <div className="min-h-screen pt-20 bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-500 border-t-transparent"></div>
      </div>
    );
  }

  const availableCourseIds = Object.keys(COURSES);
  const allSelected =
    availableCourseIds.length > 0 &&
    availableCourseIds.every((id) => formState.selectedCourseIds.includes(id));

  const toggleAll = () =>
    setFormState((prev) => ({
      ...prev,
      selectedCourseIds: allSelected ? [] : availableCourseIds,
    }));

  const query = courseQuery.trim().toLowerCase();
  const visibleCourses = Object.entries(COURSES).filter(
    ([, c]) =>
      !query ||
      c.name.toLowerCase().includes(query) ||
      (c.municipality || '').toLowerCase().includes(query)
  );

  const canSearch = selectedCourseIds.length > 0;

  return (
    <div className="pb-16">
      {/* Hero ------------------------------------------------------------- */}
      <header className="px-4 pt-6 sm:pt-10 pb-7 sm:pb-9">
        <div className="mx-auto max-w-4xl text-center">
          <span className="tiu-hero-pill">
            <span className="tiu-hero-pill-dot" />
            {Object.keys(COURSES).length} courses across BC
          </span>

          <h1 className="tiu-display mt-5">
            Vancouver Golf Tee Times. Every Course, One Search.
          </h1>

          <p className="tiu-hero-sub mt-4 mx-auto max-w-xl">
            Stop checking a dozen booking sites. Compare live golf tee times and prices
            across every public course in Vancouver and {Object.keys(COURSES).length} courses
            throughout British Columbia.
          </p>

          <div className="mt-6 flex flex-col items-center gap-3">
            <a href="#search" className="tiu-btn tiu-btn-lg tiu-btn-primary">
              Find a tee time
            </a>
            <p className="tiu-muted">Every course, free. No account needed.</p>
          </div>
        </div>
      </header>

      <form onSubmit={handleSubmit} id="search" className="px-4">
        <div className="mx-auto max-w-6xl">
          <div className="tiu-frame">
            <div className="bg-white">
          {/* Step 1: courses ---------------------------------------------- */}
          <section className="overflow-hidden">
            <div className="tiu-card-head">
              <div>
                <h2 className="tiu-h2">Choose your courses</h2>
                <p className="tiu-muted">{selectedCourseIds.length} selected</p>
              </div>
              <button type="button" onClick={toggleAll} className="tiu-btn tiu-btn-secondary">
                {allSelected ? 'Clear all' : 'Select all'}
              </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Map gets the majority of the width and full bleed height */}
              <div className="lg:col-span-3 relative border-b lg:border-b-0 lg:border-r border-slate-200 lg:h-[626px]">
                <CourseMap
                  selectedCourseIds={selectedCourseIds}
                  onCourseToggle={handleCourseToggle}
                  key="map-above"
                />
              </div>

              {/* Course list */}
              <div className="lg:col-span-2 flex flex-col min-h-0 lg:h-[626px]">
                <div className="p-3 border-b border-slate-200">
                  <input
                    type="text"
                    value={courseQuery}
                    onChange={(e) => setCourseQuery(e.target.value)}
                    placeholder="Search courses or cities"
                    className="tiu-input"
                    aria-label="Filter courses"
                  />
                </div>
                <div className="tiu-scroll tiu-course-list p-2">
                  {visibleCourses.length === 0 && (
                    <p className="tiu-muted p-3">No courses match "{courseQuery}".</p>
                  )}
                  {visibleCourses.map(([id, course]) => {
                    const selected = selectedCourseIds.includes(id);
                    return (
                      <button
                        type="button"
                        key={id}
                        onClick={() => handleCourseToggle(id)}
                        aria-pressed={selected}
                        className={`tiu-option ${selected ? 'is-selected' : ''}`}
                      >
                        <span className={`tiu-check ${selected ? 'is-on' : ''}`} aria-hidden="true">
                          {selected && (
                            <svg viewBox="0 0 12 10" fill="none">
                              <path
                                d="M1 5.2 4.2 8.4 11 1.6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </span>
                        <span className="min-w-0 flex-1">
                          <span className="tiu-option-name">{course.name}</span>
                          <span className="tiu-option-meta">{course.municipality}</span>
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </section>

          {/* Step 2: filters ---------------------------------------------- */}
          <section className="border-t border-slate-200">
            <div className="tiu-card-head">
              <div>
                <h2 className="tiu-h2">Narrow it down</h2>
                <p className="tiu-muted">Date, players, time and budget.</p>
              </div>
            </div>

            <div className="p-5 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
              <div>
                <label className="tiu-label" htmlFor="date">Date</label>
                <input
                  type="date"
                  id="date"
                  value={date}
                  onChange={(e) => setFormState((prev) => ({ ...prev, date: e.target.value }))}
                  className="tiu-input"
                  required
                />
              </div>

              <div>
                <span className="tiu-label">Players</span>
                <div className="tiu-segment w-full">
                  {['1', '2', '3', '4'].map((num) => (
                    <button
                      type="button"
                      key={num}
                      aria-pressed={players === num}
                      onClick={() => setFormState((prev) => ({ ...prev, players: num }))}
                      className="tiu-segment-item"
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <span className="tiu-label">Time of day</span>
                <div className="tiu-segment w-full">
                  {[
                    { value: 'morning', label: 'Morning' },
                    { value: 'afternoon', label: 'Afternoon' },
                    { value: 'evening', label: 'Evening' },
                    { value: 'all', label: 'All day' },
                  ].map(({ value, label }) => (
                    <button
                      type="button"
                      key={value}
                      aria-pressed={timeRange === value}
                      onClick={() => setFormState((prev) => ({ ...prev, timeRange: value }))}
                      className="tiu-segment-item"
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-baseline justify-between">
                  <span className="tiu-label">Max price</span>
                  <span className="tiu-price text-lg">${maxPrice}</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="200"
                  step="10"
                  value={maxPrice}
                  onChange={(e) =>
                    setFormState((prev) => ({ ...prev, maxPrice: parseInt(e.target.value) }))
                  }
                  className="tiu-range mt-3"
                  aria-label="Maximum price"
                />
                <div className="flex justify-between tiu-muted mt-2">
                  <span>$0</span>
                  <span>$200+</span>
                </div>
              </div>
            </div>
          </section>
              {/* Search action, inside the tool */}
              <div className="tiu-search-bar">
                <p className="tiu-actionbar-text">
                  {canSearch ? (
                    <>
                      Searching <strong>{selectedCourseIds.length}</strong>{' '}
                      {selectedCourseIds.length === 1 ? 'course' : 'courses'} for {players}{' '}
                      {players === '1' ? 'player' : 'players'}
                    </>
                  ) : (
                    'Select at least one course to search'
                  )}
                </p>
                <button
                  type="submit"
                  disabled={!canSearch}
                  className="tiu-btn tiu-btn-lg tiu-btn-primary w-full sm:w-auto"
                >
                  Search tee times
                </button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  );
};

export default SearchForm;